export enum CardService {
  CREATE = 'CREATE',
  REFILL = 'REFILL',
}
